import { render, staticRenderFns } from "./addPay1.vue?vue&type=template&id=0ded61cb&scoped=true&"
import script from "./addPay1.vue?vue&type=script&lang=js&"
export * from "./addPay1.vue?vue&type=script&lang=js&"
import style0 from "./addPay1.vue?vue&type=style&index=0&id=0ded61cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded61cb",
  null
  
)

export default component.exports